import { useEffect, useState } from 'react';

const reviews = [
  {
    name: '',
    subtitle: '',
    // rating: 5,
    text: 'Streamline your vehicle title paperwork, tackle state requirements head-on, and manage fees with precision today.',
  },
  {
    name: '',
    subtitle: '',
    // rating: 4,
    text: 'Your One-Stop Solution for Smooth, Compliant Vehicle Transactions.',
  },
  {
    name: '',
    subtitle: '',
    // rating: 5,
    text: 'Collaborating with Financial Institutions Nationwide.',
  },
];

const LoginSideBar = () => {
   const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % reviews.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-white h-[100%]">
      <div className="bg-[#235D38] rounded-2xl h-[100%] flex flex-col justify-between"
        style={{
          backgroundImage: `
            url(/vectors/frame.png),
            url(/vectors/Star.png),
            url(/vectors/Ellipse.png),
            url(/vectors/dot.png),
            url(/vectors/dots_frame.png)
          `,
          backgroundSize: `
            4vw,
            1.5vw,
            4vw,
            5vw,
            6vw
          `,
          backgroundPosition: `
            20% 20%,
            80% 10%,
            64% 68%,
            100% 68%,
            0% 100%
          `,
          backgroundRepeat: 'no-repeat, no-repeat, no-repeat, no-repeat, no-repeat'
        }}
        >
        <div className="flex items-center ml-12 mt-12">
          <div className="bg-white h-11 w-11 rounded-full flex items-center justify-center">
            <img className="rounded-full" src="/logo.png" alt="Dashboard visual" />
          </div>
          <div className="text-1xl font-bold text-white ml-2">
            DMV Navigator
          </div>
        </div>

        <div className="flex justify-center mx-12">
          <div className="z-10 relative top-36 left-12">
            <img className="h-80 w-48 z-10" src="login.png" alt=""/>
          </div>

          <div className="z-4">
            <img className="w-[500px] z-0" src="login2.png" alt=""/>
          </div>

          <div className="z-10 flex items-center bg-white px-3 py-2 rounded-lg h-fit relative top-10 right-20 shadow-xl">
            <img className="h-6 w-20 z-10" src="Avatar group.png" alt=""/>
            <div className="font-semibold">
              2k+ <span className="font-normal">Users</span>
            </div>
          </div>
        </div>

        <div className="text-center px-6 md:px-32 lg:px-48 py-6 relative">
          {reviews[current].name &&
            <div className="text-2xl text-white font-bold">{reviews[current].name}</div>
          }

          {reviews[current].subtitle &&
            <div className="text-white mb-2">
              {reviews[current].subtitle}
              <span className="text-yellow-400 ml-2">✮ {reviews[current].rating}</span>
            </div>
          }

          <p className="text-white text-sm h-14">{reviews[current].text}</p>

          {/* Pagination dots */}
          <div className="flex justify-center mt-4 gap-2">
            {reviews.map((_, index) => (
              <div
                key={index}
                className={`h-2 w-4 rounded-full ${
                  index === current ? 'bg-white' : 'bg-green-700'
                }`}
              ></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginSideBar;
